import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    data() {
        return {
            basePriceAttributes: {
                size_id: null,
                orderable_type: null,
                newsletter_type_id: null,
                color_type: null,
                quantity: 0,
                newsletter_pages: null,
                max_chars: null,
                pricing_model_id: null,
                weekly_calendar: false,
                monthly_calendar: false,
                each_calendar: false,
            },
        };
    },
};
